import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { ContentSection } from '@/utils/tos';
import * as Typography from '@/components/shadcn/typography';
import Section from '@/components/ui/tos/desktop/Section';

export interface Props {
  data: {
    title: string;
    sections: ContentSection[];
  };
  setCurrentContent: Dispatch<SetStateAction<string | null>>;
  page?: string;
}

const Content = ({ data, setCurrentContent, page }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const topRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView();
    }
  }, [page]);

  return (
    <div
      className="no-scrollbar col-span-2 h-[calc(100vh-7rem)] overflow-auto"
      ref={ref}>
      <div className="py-4" ref={topRef}>
        <Typography.H3>{data.title}</Typography.H3>
      </div>
      {data.sections.map(section => (
        <Section
          section={section}
          setCurrentContent={setCurrentContent}
          key={section.title}
          root={ref}
        />
      ))}
    </div>
  );
};

export default Content;
